import React from "react";

const items = ["Airport Transfers", "Weddings", "Corporate Travel", "Night Out", "Hourly Hire", "City to City"];

export const Marquee = () => {
  const loop = [...items, ...items];
  return (
    <div className="py-8 border-y border-white/10 bg-[var(--nl-bg-2)] overflow-hidden" data-testid="marquee">
      <div className="marquee-track">
        {loop.map((item, i) => (
          <div key={i} className="flex items-center shrink-0">
            <span className="font-serif italic text-3xl md:text-5xl text-white/80 px-12">{item}</span>
            <span className="text-gold text-2xl">◆</span>
          </div>
        ))}
      </div>
    </div>
  );
};
